export function FileSizeException(size) {
    this.maxSize = size;
}
